import { useNavigate } from 'react-router-dom'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { EmptyStateLayout } from 'modules/trainings/components/EmptyStateLayout'

import createRequestsImage from './images/create-requests.png'
import enableSettingsImage from './images/enable-settings.png'

export function RequestsEmptyState({
  emptyCatalog,
  canCreate,
  settingsEnabled,
}: {
  emptyCatalog: boolean
  canCreate: boolean
  settingsEnabled: boolean
}) {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  if (!settingsEnabled) {
    return (
      <EmptyStateLayout>
        <Box maxWidth="s400" minWidth="s400" maxHeight="s360" minHeight="s360">
          <img src={enableSettingsImage}></img>
        </Box>
        <Box gap="s24" maxWidth="s600" textAlign="center" alignItems="center">
          <Box gap="s8">
            <Text size="400" color="grey1000" weight="semibold">
              {i18n.t('trainings.training_requests.requests.empty_state.title')}
            </Text>
            <Text size="300" color="grey800" weight="normal">
              {i18n.t('trainings.training_requests.requests.empty_state.description')}
            </Text>
          </Box>
          <Button.Router to={navigation.settings.trainings.fullPath()}>
            {i18n.t('trainings.training_requests.requests.empty_state.cta')}
          </Button.Router>
        </Box>
      </EmptyStateLayout>
    )
  }

  return (
    <EmptyStateLayout>
      <Box maxWidth="s600" minWidth="s600" maxHeight="s360" minHeight="s360">
        <img src={createRequestsImage}></img>
      </Box>
      <Box gap="s24" maxWidth="s400" textAlign="center" alignItems="center">
        {canCreate ? (
          <>
            <Text size="400" color="grey1000" weight="semibold">
              {i18n.t('trainings.training_requests.my_requests.empty_state.title')}
            </Text>
            <Button
              iconName="add"
              onClick={() => {
                navigate(navigation.myTrainings.requests.list.new.fullPath())
                track(
                  trackingEvents.training.trainingRequest.addTrainingRequest.newProposal.start,
                  {
                    from: 'training_request_empty_space',
                  }
                )
              }}
            >
              {i18n.t('trainings.training_requests.my_requests.empty_state.cta')}
            </Button>
            {!emptyCatalog && (
              <Box
                cursor="pointer"
                onClick={() => {
                  navigate(navigation.myTrainings.catalog.list.fullPath())
                  track(trackingEvents.training.trainingRequest.gotToTrainingCatalog, {
                    from: 'training_request_empty_space',
                  })
                }}
                flexDirection="row"
                alignItems="center"
                gap="s4"
              >
                <Text size="300" color="grey1000" weight="medium">
                  {i18n.t('trainings.training_requests.my_requests.check_catalog')}
                </Text>
                <Icon.Medium icon="arrow-right" color="grey1000" />
              </Box>
            )}
          </>
        ) : (
          <>
            <Text size="400" color="grey1000" weight="semibold">
              {i18n.t('trainings.training_requests.my_requests.empty_state.title_no_permissions')}
            </Text>
            <Text size="300" color="grey800" weight="normal">
              {i18n.t(
                'trainings.training_requests.my_requests.empty_state.description_no_permissions'
              )}
            </Text>
          </>
        )}
      </Box>
    </EmptyStateLayout>
  )
}
